import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resolveProcessReturnPath } from '../routing/processNavigation.ts';

/** Resolves `processReturnPath` from location state and navigates back to it (or `fallback`). */
export function useProcessBackNavigation(fallback: string) {
  const location = useLocation();
  const navigate = useNavigate();

  const returnPath = useMemo(
    () => resolveProcessReturnPath(location, fallback),
    [location, fallback]
  );

  const goBack = useCallback(() => {
    navigate(returnPath);
  }, [navigate, returnPath]);

  return { returnPath, goBack };
}
